import { GraphQLError } from 'graphql';
import { useContext } from 'react';
import { PreferenceInput, ShareRequestInput } from 'sr-types/lib/account/v1/graphql';
import { Reference } from 'sr-types/lib/search/v1/graphql';
import { failedToastMessage, successToastMessage } from '../../utils/commonUtils';
import { savePreferenceMutation } from '../Preferences';
import { UserContext } from '../UserContext';

export type PreferenceInputs = {
    preferenceInput: PreferenceInput;
    shareInput?: ShareRequestInput | null;
    showSuccessMessages?: boolean;
};

export type PreferenceSuccessType = {
    id: string;
    reference: Reference;
    errors?: readonly GraphQLError[];
};

type PreferenceResponseType = {
    data?: {
        savePreference: PreferenceSuccessType;
    };
    errors?: readonly GraphQLError[];
};

export const useSavePreferences = () => {
    const { userProfile, application } = useContext(UserContext);

    const userAccountId = userProfile?.accountId || '';

    const savePreferences = async ({
        preferenceInput,
        shareInput,
        showSuccessMessages = true
    }: PreferenceInputs): Promise<PreferenceSuccessType> => {
        try {
            const response: PreferenceResponseType = await savePreferenceMutation(
                userAccountId,
                { ...preferenceInput, application: application.name },
                shareInput
            );

            const savePreferenceResult = response.data.savePreference;

            if (savePreferenceResult?.errors) {
                throw savePreferenceResult.errors;
            }
            if (showSuccessMessages) {
                successToastMessage('preference.saved.success');
            }
            return savePreferenceResult;
        } catch (error) {
            failedToastMessage('preference.saved.error');
            throw error;
        }
    };

    return { savePreferences };
};
